import {
  adminClient,
  inferAdditionalFields,
  organizationClient,
  twoFactorClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from "../../server/auth";

// Gleiche Origin (Dev: Vite-Proxy → :3000), daher keine baseURL nötig.
// inferAdditionalFields: Typen der Zusatzfelder (locale) vom Server —
// reiner Typ-Import, landet nicht im Bundle.
// organizationClient: Mitglieder des aktiven Accounts (list/updateRole/remove)
// und der Account-Wechsel (setActive) — Accounts heißen im Plugin "organization".
export const authClient = createAuthClient({
  plugins: [
    adminClient(),
    organizationClient(),
    twoFactorClient(),
    inferAdditionalFields<typeof auth>(),
  ],
});

/** Globale Rolle (Admin-Plugin): "admin" = Betreiber der Instanz. Zentral getypt statt überall gecastet. */
export function userRole(user: { role?: string | null } | Record<string, unknown>): string {
  return typeof (user as { role?: unknown }).role === "string"
    ? ((user as { role: string }).role ?? "member")
    : "member";
}
